export default {
  namespaced: true,
  state: {
    // 用户信息
    details: {},
    supervisionDetails: {},
    fabricDetails: {},
    factoryDetails: {},
    imgList: [],
    supervisionImgList: [],
    fabricImgList: [],
    factoryImgList: [],
  },
  actions: {
    async getImg({ commit }, id) {
      const imgList1 = {
        productPhoto: [], //产品图片
        cleargovphoto: [], //廉政申明及抽样封箱
        factorycardphoto: [], //厂牌
        remarkphoto: [], //备注图片
        // 货物描述
        descriptionOfGoods: {
          packed: [], //大货箱堆
          unpacked: [], //未入箱成品
          semi: [], //半成品
          sampboxphoto: [], //抽样箱堆
          sampproductphoto: [], //抽样产品
        },
        // 包装描述
        descriptionOfPack: {
          cartonseal: [], //外箱封装方式
          frontmark: [], //外箱正唛
          sidemark: [], //外箱侧唛
          cartonbarcode: [], //外箱条码
          cartonsize: [], //外箱尺寸
          cartonweight: [], //外箱重量（带产品）
          innerpack: [], //开箱后包装
          cartonlayer: [], //外箱瓦楞质量
          packdetail: [], //单件产品包装方式
          packsize: [], //单件产品包装尺寸
          innerbox: [], //内盒
          other: [], //其他
        },
        //产品工艺
        productProcess: {
          front: [], // 正面
          side: [], // 侧面
          back: [], // 背面
          inside: [], // 	内部
          printdetail: [], // 	细节
          productsize: [], //产品尺寸
        },
        //瑕疵品处理
        defectiveGoods: {
          defectarea: [], //瑕疵品堆放区
          groupphoto: [], //QC、工厂负责人与瑕疵品堆放区合影
          qcgroupphoto: [], //QC与瑕疵品堆放区合影
          replace: [], //替换
          cancel: [], //报废
          rework: [], //返工
        },
      };
      const data = await this.$http.post('/hzwmj/inspect-media/selDate', {
        reportId: id,
      });
      if (data.data) {
        data.data.forEach(item => {
          console.log('item==========', item);
          if (item.mediaDescribe == 'productPhoto') {
            imgList1.productPhoto.push(item);
          } else if (item.mediaDescribe == 'cleargovphoto') {
            imgList1.cleargovphoto.push(item);
          } else if (item.mediaDescribe == 'factorycardphoto') {
            imgList1.factorycardphoto.push(item);
          } else if (item.mediaDescribe == 'remarkphoto') {
            imgList1.remarkphoto.push(item);
          } else if (item.mediaDescribe == 'packed') {
            imgList1.descriptionOfGoods.packed.push(item);
          } else if (item.mediaDescribe == 'unpacked') {
            imgList1.descriptionOfGoods.unpacked.push(item);
          } else if (item.mediaDescribe == 'semi') {
            imgList1.descriptionOfGoods.semi.push(item);
          } else if (item.mediaDescribe == 'sampboxphoto') {
            imgList1.descriptionOfGoods.sampboxphoto.push(item);
          } else if (item.mediaDescribe == 'sampproductphoto') {
            imgList1.descriptionOfGoods.sampproductphoto.push(item);
          } else if (item.mediaDescribe == 'cartonseal') {
            imgList1.descriptionOfPack.cartonseal.push(item);
          } else if (item.mediaDescribe == 'frontmark') {
            imgList1.descriptionOfPack.frontmark.push(item);
          } else if (item.mediaDescribe == 'sidemark') {
            imgList1.descriptionOfPack.sidemark.push(item);
          } else if (item.mediaDescribe == 'cartonbarcode') {
            imgList1.descriptionOfPack.cartonbarcode.push(item);
          } else if (item.mediaDescribe == 'cartonsize') {
            imgList1.descriptionOfPack.cartonsize.push(item);
          } else if (item.mediaDescribe == 'cartonweight') {
            imgList1.descriptionOfPack.cartonweight.push(item);
          } else if (item.mediaDescribe == 'innerpack') {
            imgList1.descriptionOfPack.innerpack.push(item);
          } else if (item.mediaDescribe == 'cartonlayer') {
            imgList1.descriptionOfPack.cartonlayer.push(item);
          } else if (item.mediaDescribe == 'packdetail') {
            imgList1.descriptionOfPack.packdetail.push(item);
          } else if (item.mediaDescribe == 'packsize') {
            imgList1.descriptionOfPack.packsize.push(item);
          } else if (item.mediaDescribe == 'innerbox') {
            imgList1.descriptionOfPack.innerbox.push(item);
          } else if (item.mediaDescribe == 'other') {
            imgList1.descriptionOfPack.other.push(item);
          } else if (item.mediaDescribe == 'front') {
            imgList1.productProcess.front.push(item);
          } else if (item.mediaDescribe == 'side') {
            imgList1.productProcess.side.push(item);
          } else if (item.mediaDescribe == 'back') {
            imgList1.productProcess.back.push(item);
          } else if (item.mediaDescribe == 'inside') {
            imgList1.productProcess.inside.push(item);
          } else if (item.mediaDescribe == 'printdetail') {
            imgList1.productProcess.printdetail.push(item);
          } else if (item.mediaDescribe == 'productsize') {
            imgList1.productProcess.productsize.push(item);
          } else if (item.mediaDescribe == 'defectarea') {
            imgList1.defectiveGoods.defectarea.push(item);
          } else if (item.mediaDescribe == 'groupphoto') {
            imgList1.defectiveGoods.groupphoto.push(item);
          } else if (item.mediaDescribe == 'cancel') {
            imgList1.defectiveGoods.cancel.push(item);
          } else if (item.mediaDescribe == 'rework') {
            imgList1.defectiveGoods.rework.push(item);
          } else if (item.mediaDescribe == 'qcgroupphoto') {
            imgList1.defectiveGoods.qcgroupphoto.push(item);
          } else if (item.mediaDescribe == 'replace') {
            imgList1.defectiveGoods.replace.push(item);
          }
        });
        commit('save', { imgList: imgList1 });
      }
    },
    async getSupervisionImg({ commit }, id) {
      const imgList1 = {
        productPhoto: [], //产品图片
        // 装柜数量
        descriptionOfGoods: {
          lmediaGates: [], //工厂大门
          lmediaPacked: [], //大货箱堆
          lmediaUnpacked: [], //未入箱成品
          lmediaSemi: [], //半成品
        },
        // 货物包装
        descriptionOfPack: {
          lmediaCartonseal: [], //外箱封装方式
          lmediaFrontmark: [], //外箱正唛
          lmediaSidemark: [], //外箱侧唛
          lmediaCartonbarcode: [], //外箱条码
          lmediaCartonsize: [], //外箱尺寸
          lmediaCartonweight: [], //外箱重量（带产品）
          lmediaInnerpack: [], //开箱后包装
          lmediaCartonlayer: [], //外箱瓦楞质量
          lmediaInnerbox: [], //内盒
          lmediaPackdetail: [], //单件产品包装方式
          lmediaOther: [], //其他
        },
        //装箱产品
        productProcess: {
          lmediaFront: [], // 正面
          lmediaSide: [], // 侧面
          lmediaBack: [], // 背面
          lmediaInside: [], // 	内部
          lmediaPrintdetail: [], // 细节
          lmediaColor: [], //颜色对比
        },
        //拖车货柜
        cart: {
          lmediaTruckfront: [], //货柜前面照
          lmediaLicence: [], //车牌
          lmediaContainerside: [], //货柜侧面
          lmediaCheck: [], //装柜前柜内检查
          lmediaContinside: [], //货柜内壁柜号
          lmediaContoutside: [], //货柜外壁柜号
          lmediaBadgeback: [], //货柜车尾照
        },
        processMonitoring: {
          lmediaSealphoto: [], //封柜照片
          lmediaLoadquarter: [], //装柜过程1/4
          lmediaLoadhalf: [], //装柜过程1/2
          lmediaLoadthreequarter: [], //装柜过程3/4
          lmediaLoadfinish: [], //全部装完
          lmediaRightclose: [], //右侧柜门关闭
          lmediaBothclose: [], //双侧柜门关闭
        },
        closures: {
          lmediaSeal: [],
          lmediaSealno: [],
        },
        // //瑕疵品处理
        // defectiveGoods: {
        //   defectarea: [], //瑕疵品堆放区
        //   groupphoto: [], //QC、工厂负责人与瑕疵品堆放区合影
        //   cancel: [], //报废
        //   rework: [], //返工
        // },
      };
      const data = await this.$http.post('/hzwmj/loadig-media/getLoadigMedia', {
        ireportId: id,
      });
      if (data.data) {
        data.data.forEach(item => {
          if (item.mediaDescribe == 'productPhoto') {
            imgList1.productPhoto.push(item);
          } else if (item.mediaDescribe == 'lmediaGates') {
            imgList1.descriptionOfGoods.lmediaGates.push(item);
          } else if (item.mediaDescribe == 'lmediaPacked') {
            imgList1.descriptionOfGoods.lmediaPacked.push(item);
          } else if (item.mediaDescribe == 'lmediaUnpacked') {
            imgList1.descriptionOfGoods.lmediaUnpacked.push(item);
          } else if (item.mediaDescribe == 'lmediaSemi') {
            imgList1.descriptionOfGoods.lmediaSemi.push(item);
          } else if (item.mediaDescribe == 'lmediaCartonseal') {
            imgList1.descriptionOfPack.lmediaCartonseal.push(item);
          } else if (item.mediaDescribe == 'lmediaFrontmark') {
            imgList1.descriptionOfPack.lmediaFrontmark.push(item);
          } else if (item.mediaDescribe == 'lmediaSidemark') {
            imgList1.descriptionOfPack.lmediaSidemark.push(item);
          } else if (item.mediaDescribe == 'lmediaCartonbarcode') {
            imgList1.descriptionOfPack.lmediaCartonbarcode.push(item);
          } else if (item.mediaDescribe == 'lmediaCartonsize') {
            imgList1.descriptionOfPack.lmediaCartonsize.push(item);
          } else if (item.mediaDescribe == 'lmediaCartonweight') {
            imgList1.descriptionOfPack.lmediaCartonweight.push(item);
          } else if (item.mediaDescribe == 'lmediaInnerpack') {
            imgList1.descriptionOfPack.lmediaInnerpack.push(item);
          } else if (item.mediaDescribe == 'lmediaCartonlayer') {
            imgList1.descriptionOfPack.lmediaCartonlayer.push(item);
          } else if (item.mediaDescribe == 'lmediaInnerbox') {
            imgList1.descriptionOfPack.lmediaInnerbox.push(item);
          } else if (item.mediaDescribe == 'lmediaPackdetail') {
            imgList1.descriptionOfPack.lmediaPackdetail.push(item);
          } else if (item.mediaDescribe == 'lmediaOther') {
            imgList1.descriptionOfPack.lmediaOther.push(item);
          } else if (item.mediaDescribe == 'lmediaFront') {
            imgList1.productProcess.lmediaFront.push(item);
          } else if (item.mediaDescribe == 'lmediaSide') {
            imgList1.productProcess.lmediaSide.push(item);
          } else if (item.mediaDescribe == 'lmediaBack') {
            imgList1.productProcess.lmediaBack.push(item);
          } else if (item.mediaDescribe == 'lmediaInside') {
            imgList1.productProcess.lmediaInside.push(item);
          } else if (item.mediaDescribe == 'lmediaPrintdetail') {
            imgList1.productProcess.lmediaPrintdetail.push(item);
          } else if (item.mediaDescribe == 'lmediaColor') {
            imgList1.productProcess.lmediaColor.push(item);
          } else if (item.mediaDescribe == 'lmediaTruckfront') {
            imgList1.cart.lmediaTruckfront.push(item);
          } else if (item.mediaDescribe == 'lmediaLicence') {
            imgList1.cart.lmediaLicence.push(item);
          } else if (item.mediaDescribe == 'lmediaContainerside') {
            imgList1.cart.lmediaContainerside.push(item);
          } else if (item.mediaDescribe == 'lmediaCheck') {
            imgList1.cart.lmediaCheck.push(item);
          } else if (item.mediaDescribe == 'lmediaContinside') {
            imgList1.cart.lmediaContinside.push(item);
          } else if (item.mediaDescribe == 'lmediaContoutside') {
            imgList1.cart.lmediaContoutside.push(item);
          } else if (item.mediaDescribe == 'lmediaBadgeback') {
            imgList1.cart.lmediaBadgeback.push(item);
          } else if (item.mediaDescribe == 'lmediaSealphoto') {
            imgList1.processMonitoring.lmediaSealphoto.push(item);
          } else if (item.mediaDescribe == 'lmediaLoadquarter') {
            imgList1.processMonitoring.lmediaLoadquarter.push(item);
          } else if (item.mediaDescribe == 'lmediaLoadhalf') {
            imgList1.processMonitoring.lmediaLoadhalf.push(item);
          } else if (item.mediaDescribe == 'lmediaLoadthreequarter') {
            imgList1.processMonitoring.lmediaLoadthreequarter.push(item);
          } else if (item.mediaDescribe == 'lmediaLoadfinish') {
            imgList1.processMonitoring.lmediaLoadfinish.push(item);
          } else if (item.mediaDescribe == 'lmediaRightclose') {
            imgList1.processMonitoring.lmediaRightclose.push(item);
          } else if (item.mediaDescribe == 'lmediaBothclose') {
            imgList1.processMonitoring.lmediaBothclose.push(item);
          } else if (item.mediaDescribe == 'lmediaSeal') {
            imgList1.closures.lmediaSeal.push(item);
          } else if (item.mediaDescribe == 'lmediaSealno') {
            imgList1.closures.lmediaSealno.push(item);
          }
        });
        commit('save', { supervisionImgList: imgList1 });
      }
    },
    async getfabricImg({ commit }, id) {
      const imgList1 = {
        fmediaProductphoto: [], //产品图片
        // 大货情况
        descriptionOfGoods: {
          fmediaPacked: [], //大货成卷卷堆
          fmediaUnpacked: [], //未成卷产品
          fmediaPackinglist: [], //码单
        },
        // 包装情况
        descriptionOfPack: {
          fmediaRollpackeddetails: [], //单卷面料封装方式
          fmediaShippingmark: [], //唛头及产品标签
          fmediaInnerpackingdetails: [], //开包装产品展示
          fmediaCollateral: [], //辅料/产品细节展示
        },
        closures: {
          fmediaFourpointsystem: [], //4分制评分表
        },
      };
      const data = await this.$http.post(
        '/hzwmj/fabric-media/seachFabricMedias',
        {
          ireportId: id,
        },
      );
      if (data) {
        data.data.forEach(item => {
          if (item.mediaDescribe == 'fmediaProductphoto') {
            imgList1.fmediaProductphoto.push(item);
          } else if (item.mediaDescribe == 'fmediaPacked') {
            imgList1.descriptionOfGoods.fmediaPacked.push(item);
          } else if (item.mediaDescribe == 'fmediaUnpacked') {
            imgList1.descriptionOfGoods.fmediaUnpacked.push(item);
          } else if (item.mediaDescribe == 'fmediaPackinglist') {
            imgList1.descriptionOfGoods.fmediaPackinglist.push(item);
          } else if (item.mediaDescribe == 'fmediaRollpackeddetails') {
            imgList1.descriptionOfPack.fmediaRollpackeddetails.push(item);
          } else if (item.mediaDescribe == 'fmediaShippingmark') {
            imgList1.descriptionOfPack.fmediaShippingmark.push(item);
          } else if (item.mediaDescribe == 'fmediaInnerpackingdetails') {
            imgList1.descriptionOfPack.fmediaInnerpackingdetails.push(item);
          } else if (item.mediaDescribe == 'fmediaCollateral') {
            imgList1.descriptionOfPack.fmediaCollateral.push(item);
          } else if (item.mediaDescribe == 'fmediaFourpointsystem') {
            imgList1.closures.fmediaFourpointsystem.push(item);
          }
        });
        commit('save', { fabricImgList: imgList1 });
      }
    },
    async getfactoryImg({ commit }, id) {
      const imgList1 = {
        //基本信息
        basicImg: {
          freportBusinesslicense: [], //营业执照
          freportCertificate: [], //房产证文件
          freportAgreements: [], //租赁合同
          freportIdcard: [], //法人身份证（正反）
          freportCompanyawards: [], //企业荣誉证书
        },
        // 产品信息
        descriptionOfGoods: {
          freportProductcatalogue: [], //产品目录
          freportMainproduct: [], //主营产品
          freportQualitycertificate: [], //产品认证证书
          freportProductsawards: [], //产品荣誉证书
          freportBrochure: [], //产品宣传册
        },
        // 包装情况
        descriptionOfPack: {
          freportGate: [], //工厂大门
          freportOffice: [], //办公区域
          freportShowroom: [], //样品室
          freportWorkshop: [], //生产车间
          freportMaterialwarehouse: [], //原料仓库
          freportFgwarehouse: [], //成品仓库
          freportStaffdormitory: [], //员工宿舍楼
          freportCanteen: [], //食堂
          freportInfirmary: [], //医务室
        },
        //设备信息
        productDetails: {
          freportEquipmentlist: [], //设备清单
          freportMaintenancerecords: [], //设备保养（维护）记录
        },
        //人力资源
        processMonitoring: {
          freportStafflist: [], //员工花名册
          freportStaffarchives: [], //员工档案记录
          freportAttendance: [], //近3个月考勤记录
          freportSalary: [], //近3个月工资记录
        },
        closures: {
          freportTaxbill: [], //近3个月纳税申报表
          freportRentrecords: [], //近3个月房租缴纳凭证
          freportUtilitybills: [], //近3个月水电缴纳凭证
          freportInputinvoices: [], //近6个月原料进项发票
          freportOutputinvoices: [], //近6个月销项发票
          freportMaterialrecords: [], //原料仓库进出货记录
          freportProductrecords: [], //成品仓库进出货记录
          freportBillmaterial: [], //产品BOM物料清单
          freportProductionplan: [], //生产计划单
          freportProductionsummary: [], //生产报表
          freportInspectionrecords: [], //品质检验记录
          freportNotdocument: [], //工厂未能提供文件资料清单
        },
      };
      const data = await this.$http.post(
        '/hzwmj/factory-media/seachFactoryMedia',
        {
          freportId: id,
        },
      );
      if (data.data) {
        data.data.forEach(item => {
          if (item.mediaDescribe == 'freportBusinesslicense') {
            imgList1.basicImg.freportBusinesslicense.push(item);
          } else if (item.mediaDescribe == 'freportCertificate') {
            imgList1.basicImg.freportCertificate.push(item);
          } else if (item.mediaDescribe == 'freportAgreements') {
            imgList1.basicImg.freportAgreements.push(item);
          } else if (item.mediaDescribe == 'freportIdcard') {
            imgList1.basicImg.freportIdcard.push(item);
          } else if (item.mediaDescribe == 'freportCompanyawards') {
            imgList1.basicImg.freportCompanyawards.push(item);
          } else if (item.mediaDescribe == 'freportProductcatalogue') {
            imgList1.descriptionOfGoods.freportProductcatalogue.push(item);
          } else if (item.mediaDescribe == 'freportMainproduct') {
            imgList1.descriptionOfGoods.freportMainproduct.push(item);
          } else if (item.mediaDescribe == 'freportQualitycertificate') {
            imgList1.descriptionOfGoods.freportQualitycertificate.push(item);
          } else if (item.mediaDescribe == 'freportProductsawards') {
            imgList1.descriptionOfGoods.freportProductsawards.push(item);
          } else if (item.mediaDescribe == 'freportBrochure') {
            imgList1.descriptionOfGoods.freportBrochure.push(item);
          } else if (item.mediaDescribe == 'freportGate') {
            imgList1.descriptionOfPack.freportGate.push(item);
          } else if (item.mediaDescribe == 'freportOffice') {
            imgList1.descriptionOfPack.freportOffice.push(item);
          } else if (item.mediaDescribe == 'freportShowroom') {
            imgList1.descriptionOfPack.freportShowroom.push(item);
          } else if (item.mediaDescribe == 'freportWorkshop') {
            imgList1.descriptionOfPack.freportWorkshop.push(item);
          } else if (item.mediaDescribe == 'freportMaterialwarehouse') {
            imgList1.descriptionOfPack.freportMaterialwarehouse.push(item);
          } else if (item.mediaDescribe == 'freportFgwarehouse') {
            imgList1.descriptionOfPack.freportFgwarehouse.push(item);
          } else if (item.mediaDescribe == 'freportStaffdormitory') {
            imgList1.descriptionOfPack.freportStaffdormitory.push(item);
          } else if (item.mediaDescribe == 'freportCanteen') {
            imgList1.descriptionOfPack.freportCanteen.push(item);
          } else if (item.mediaDescribe == 'freportInfirmary') {
            imgList1.descriptionOfPack.freportInfirmary.push(item);
          } else if (item.mediaDescribe == 'freportEquipmentlist') {
            imgList1.productDetails.freportEquipmentlist.push(item);
          } else if (item.mediaDescribe == 'freportMaintenancerecords') {
            imgList1.productDetails.freportMaintenancerecords.push(item);
          } else if (item.mediaDescribe == 'freportStafflist') {
            imgList1.processMonitoring.freportStafflist.push(item);
          } else if (item.mediaDescribe == 'freportStaffarchives') {
            imgList1.processMonitoring.freportStaffarchives.push(item);
          } else if (item.mediaDescribe == 'freportAttendance') {
            imgList1.processMonitoring.freportAttendance.push(item);
          } else if (item.mediaDescribe == 'freportSalary') {
            imgList1.processMonitoring.freportSalary.push(item);
          } else if (item.mediaDescribe == 'freportTaxbill') {
            imgList1.closures.freportTaxbill.push(item);
          } else if (item.mediaDescribe == 'freportRentrecords') {
            imgList1.closures.freportRentrecords.push(item);
          } else if (item.mediaDescribe == 'freportUtilitybills') {
            imgList1.closures.freportUtilitybills.push(item);
          } else if (item.mediaDescribe == 'freportInputinvoices') {
            imgList1.closures.freportInputinvoices.push(item);
          } else if (item.mediaDescribe == 'freportOutputinvoices') {
            imgList1.closures.freportOutputinvoices.push(item);
          } else if (item.mediaDescribe == 'freportMaterialrecords') {
            imgList1.closures.freportMaterialrecords.push(item);
          } else if (item.mediaDescribe == 'freportProductrecords') {
            imgList1.closures.freportProductrecords.push(item);
          } else if (item.mediaDescribe == 'freportBillmaterial') {
            imgList1.closures.freportBillmaterial.push(item);
          } else if (item.mediaDescribe == 'freportProductionplan') {
            imgList1.closures.freportProductionplan.push(item);
          } else if (item.mediaDescribe == 'freportProductionsummary') {
            imgList1.closures.freportProductionsummary.push(item);
          } else if (item.mediaDescribe == 'freportInspectionrecords') {
            imgList1.closures.freportInspectionrecords.push(item);
          } else if (item.mediaDescribe == 'freportNotdocument') {
            imgList1.closures.freportNotdocument.push(item);
          }
        });
        commit('save', { factoryImgList: imgList1 });
      }
    },
  },
  mutations: {
    /**
     * 保存状态
     * @param state
     * @param payload
     */
    save(state, payload) {
      console.log(payload);
      // state.details = payload;
      for (let key of Object.keys(payload)) {
        state[key] = payload[key];
      }
    },
  },
};
